/** @format */

import ResourceLessonPage from "../lessonPage/ResourceLessonPage";
import PrintableApp from "../printable/PrintableApp";
import Dashboard from "../dashboard/Dashboard";
import PageNotFound from "../pageNotFound/PageNotFound";
import Resource from "./Resource";

const resourcesRoutes = [
  {
    path: ":resourceId",
    element: <Resource />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: ":lessonId/:pageId", element: <ResourceLessonPage /> },
      { path: "*", element: <PageNotFound itemName={"Page"} /> },
    ],
  },
  {
    path: "print/:resourceId",
    element: <PrintableApp />,
  },
];

export default resourcesRoutes;
